import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selected", "toggleable"]
  static values = {
    show: { type: String, default: "true" },
    display: { type: String, default: "block" }
  }

  connect() {
    this.toggle()
  }

  toggle() {
    const selectedInput = this.hasSelectedTarget
      ? this.selectedTarget
      : this.element.querySelector('input[type="radio"]:checked'); // fallback when no selected target (e.g. legacy radio-only markup)
    const selectedValue = selectedInput?.type === "checkbox" ? selectedInput?.checked : selectedInput?.value;
    this.toggleableTargets.forEach(target => {
      target.style.display = String(selectedValue) === String(this.showValue) ? this.displayValue : "none"
    })
  }
}
